<template>
<div>
  <div class="header">
    <Navbar
     main-title="产品追溯平台"
     sub-title="Product Traceable Platform"
     ></Navbar>
  </div>
  <div class="main">
    <div class="sidebar">
      <Sidebar></Sidebar>
    </div>
    <div class="content">
      <transition
        appear
        enter-active-class="animated fadeIn"
      >
        <router-view></router-view>
      </transition>
    </div>
  </div>
</div>
</template>

<script>
import Navbar from "@/components/navbar/Navbar";
import Sidebar from "@/components/sidebar/Sidebar";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: { Navbar, Sidebar },
  computed: {
    ...mapGetters(["menus"])
  },
  created() {
    console.log("application")
  }
};
</script>



// WEBPACK FOOTER //
// src/components/application/Application.vue